module.exports = {
      id: "icon-audio-next-usage",
      viewBox: "0 0 35.504 35.504",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-audio-next",
      toString: function () {
        return this.url;
      }
    }